import publicity from '@/locales/en/publicity/publicity.locales';

export default {
    ...publicity,
};
